import React, { useEffect, useState } from 'react';

import { Builder } from '@builder.io/react';
import { arrayOf, object } from 'prop-types';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import styled from 'styled-components';

export const GridTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 16px;
  margin-bottom: ${({ theme }) => theme.spacing.tiny}px;
`;

export const StyledTab = styled(Tab)`
  cursor: pointer;
  margin-right: 20px;

  &[aria-selected='true'] {
    border-bottom: 3px solid ${({ theme }) => theme.colors.black};
    margin-bottom: -1px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xxlarge}px) {
    ${GridTitle} {
      font-size: 20px;
    }
  }
`;

export const StyledTabPanel = styled(TabPanel)`
  display: block;
  height: 0;
  visibility: hidden;

  &.panel-selected {
    height: auto;
    visibility: visible;
  }
`;

const StyledTabs = styled(Tabs)``;

const StyledTabsList = styled(TabList)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};
  display: flex;
  margin-bottom: 12px;
  position: relative;
`;

function TabComponentWrapper({ tabPanels, tabs }) {
  const [tabIndex, setTabIndex] = useState(0);
  const { isEditing } = Builder;

  useEffect(() => {
    // in the Builder editor if we delete the last tab while
    // selected, select the new last tab
    if (isEditing && tabIndex > tabs?.length - 1) {
      setTabIndex(tabs?.length - 1);
    }
  }, [isEditing, tabIndex, tabs]);

  return (
    <StyledTabs
      forceRenderTabPanel
      onSelect={index => setTabIndex(index)}
      selectedIndex={tabIndex}
      selectedTabPanelClassName="panel-selected"
    >
      <StyledTabsList>{tabs}</StyledTabsList>
      {tabPanels}
    </StyledTabs>
  );
}

TabComponentWrapper.propTypes = {
  tabPanels: arrayOf(object),
  tabs: arrayOf(object),
};

export default TabComponentWrapper;
